import { __assign, __extends } from "tslib";
import React from 'react';
import { LoveMeterContext } from '../LoveContext';
import ErrorBoundary from '../../ErrorBoundary';
import LoveSliderContent from './LoveSliderContent';
var LoveSlider = /** @class */ (function (_super) {
    __extends(LoveSlider, _super);
    function LoveSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoveSlider.prototype.render = function () {
        var _this = this;
        return (React.createElement(ErrorBoundary, null,
            React.createElement(LoveMeterContext.Consumer, null, function (context) { return React.createElement(LoveSliderContent, __assign({}, context, _this.props)); })));
    };
    return LoveSlider;
}(React.Component));
export { LoveSlider };
export default LoveSlider;
//# sourceMappingURL=LoveSlider.js.map